import { useState, useEffect } from "react";
import Loader from "react-loader-spinner";
import { useTranslation } from "react-i18next";

import { toastMessage } from "../../utils/toast";
import { getLocaleValue } from "../../utils";
import * as jobActions from "../../Redux/Actions/jobs";
import { clearSession } from "../../utils/initiate";
import { useDispatch } from "react-redux";

const AdditionalPayment = ({ history, match }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [currentItems, setCurrentItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const { jobID } = match.params;

  useEffect(() => {
    setLoading(true);
    jobActions
      .getPendingAdditionalPaymentDetail(jobID)
      .then((res) => {
        if (res?.data) {
          let details = res.data;
          // const detailsData = details
          //   .map(({ entityId, description, totalAmount, comments }) => {
          //     return {
          //       entityId,
          //       description,
          //       totalAmount: totalAmount.toFixed(2),
          //       comments,
          //     };
          //   });
          setCurrentItems(details);
        }
        setLoading(false);
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          toastMessage("error", `Access Denied`);
          clearSession(dispatch, history);
        }
        toastMessage(
          "error",
          err?.response?.data?.message ||
            `Unable to get the additional payment details `
        );
        setLoading(false);
      });
  }, []);

  return (
    <>
      {loading ? (
        <div className="d-flex align-items-center justify-content-center h-75vh">
          <Loader
            type="ThreeDots"
            color="#2d207d"
            height={40}
            width={40}
            style={{ textAlign: "center" }}
          />
        </div>
      ) : (
        <div>
          <div style={{ textAlign: "center" }}>
            <div>
              <span
                style={{
                  fontSize: "30px",
                  fontWeight: "500",
                  borderBottom: "5px solid #b71c1c",
                  paddingTop: "1%",
                  display: "inline-block",
                  marginBottom: "2%",
                }}
              >
                {getLocaleValue("additional_payment")}
              </span>
            </div>
          </div>
          <div className="d-flex justify-content-center">
            <div className="col-md-5">
              <div className="card" style={{ marginBottom: "0px" }}>
                <div className="d-flex mt-2">
                  <div
                    className="col-lg-12 card"
                    style={{ border: "0px solid" }}
                  >
                    <div className="card-body form-group fv-plugins-icon-container mb-0">
                      <div style={{ textAlign: "center" }}>
                        <div>
                          <span
                            className="card-title font-weight-bolder text-dark"
                            style={{ fontSize: "20px" }}
                          ></span>
                        </div>
                      </div>
                      {currentItems
                        ? currentItems.map(
                            ({
                              entityId,
                              comments,
                              totalAmount,
                              description
                            }) => {
                              return (
                                <div>
                                  <div
                                    className="d-flex "
                                    style={{ justifyContent: "space-between" }}
                                  >
                                    {" "}
                                    <div>
                                      <div>
                                        <span>
                                          {getLocaleValue(
                                            "due_payment_description_label"
                                          )}{" "}
                                          : {description}
                                        </span>
                                      </div>
                                      <div className="d-flex">
                                        <div>
                                          {getLocaleValue(
                                            "due_payment_total_amount_label"
                                          )}
                                        </div>
                                        <div>
                                          <span>: {totalAmount + " AED"}</span>
                                        </div>
                                      </div>
                                      <div>
                                        <span>
                                          {getLocaleValue("comments")} :{" "}
                                          {comments}
                                        </span>
                                      </div>
                                    </div>
                                    <button
                                      className="btn btn-primary d-flex align-items-center"
                                      onClick={() => {
                                        history.push(
                                          `/additionalPaymentCheckout/${entityId}`
                                        );
                                      }}
                                      style={{ height: "30px" }}
                                    >
                                      <span
                                        style={{
                                          fontWeight: 500,
                                          fontSize: "15px",
                                          padding: "5px",
                                        }}
                                      >
                                        {getLocaleValue("job_summary_pay_btn")}
                                      </span>
                                    </button>
                                  </div>
                                  <hr className="hr-dashed" />
                                </div>
                              );
                            }
                          )
                        : ""}
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    marginBottom: "20px",
                    marginRight: "15px",
                    justifyContent: "right",
                  }}
                >
                  {
                    <button
                      type="button"
                      className="btn btn-primary font-weight-bold d-flex align-items-center"
                      onClick={() => {
                        history.goBack();
                      }}
                    >
                      {getLocaleValue("signup_cancel_btn")}
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>{" "}
        </div>
      )}
    </>
  );
};

export default AdditionalPayment;
